export default __webpack_public_path__ + "static/media/36I-102612_-17046_0.9b58c2bb.jpg";